<template lang="html">
  <div id="service-page">

    <section class="main-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-banner">
            <div class="image">
              <div class="placed-backg img-fake" v-bind:style="{ backgroundImage: 'url(public/images/pages/services/banner-4.jpg)' }"></div>
              <img src="public/images/pages/services/banner-inyeccion-maquila.jpg">
            </div>
          </div>

          <div class="col-lg-12 col-content">
            <!-- <div class="box-float-image f-l" style="width: 423px;">
              <img src="public/images/pages/services/inyeccion-y-maquila.jpg">
            </div> -->

            <h5 class="title">Inyeccion y maquila de plastico</h5>

            <p>
              Procesos Plásticos Inyectados ofrece el servicio de Maquila de inyección de plásticos con maquinas que van de las 100 a 305 toneladas de fuerza de cierre. Contamos con una larga experiencia en inyección de todo tipo de plásticos de ingeniería. Somos especialistas en inyección de materiales técnicos, ABS, Polipropileno, Polietilenos de alta y baja densidad, poliéster, poliamida, Policarbonato,...etc.
            </p>

            <br />
            <p>
              Fabricamos piezas de plástico a medida y según los requerimientos de nuestros clientes.
            </p>

            <br />
            <h6 class="text-center subtitle">Equipo Adicional.</h6>
            <p>
              PPI trabajo todo tipo de materias primas y nos especializamos en todo tipo de plásticos de ingeniería como poliéster, poliamidas, ABS, policarbonatos y algunos de estos materiales con carga (fibra de vidrio, talcos etc.), para ello contamos con SECADORES, HUMIDIFICADORE, CARGADORES, DOSDIFICADORES y otro tipo de equipos periféricos para satisfacer los requerimientos de nuestros clientes.
            </p>

            <br />
            <h6 class="text-center subtitle"><small class="f-w-600">Especificaciones Maquinas Inyectoras.</small></h6>
            <div class="box-table table-responsive-lg">
              <table class="table table-sm">
                <thead>
                  <tr>
                    <th>Parámetros</th>
                    <th>Unidades</th>
                    <th>Fama FS 150</th>
                    <th>Engel S 150</th>
                    <th>Engel S 150</th>
                    <th>Fama FS 250</th>
                    <th>LIN-YU</th>
                  </tr>
                </thead>

                <tbody>
                  <tr>
                    <th>Dimensiones del husillo</th>
                    <td>mm</td>
                    <td>42</td>
                    <td>45</td>
                    <td>45</td>
                    <td>64</td>
                    <td>65</td>
                  </tr>
                  <tr>
                    <th>L/D del husillo</th>
                    <td>-</td>
                    <td>15 : 3</td>
                    <td>20 : 1</td>
                    <td>20 : 1</td>
                    <td>17 : 1</td>
                    <td>17:1</td>
                  </tr>
                  <tr>
                    <th>Volumen teórico de Inyección</th>
                    <td>cm³. / iny.</td>
                    <td>226</td>
                    <td>327.54</td>
                    <td>327.54</td>
                    <td>515</td>
                    <td>600</td>
                  </tr>
                  <tr>
                    <th>Medida del Disparo</th>
                    <td>grs.</td>
                    <td>235.04</td>
                    <td>327.54</td>
                    <td>327.54</td>
                    <td>530.45</td>
                    <td>615.32</td>
                  </tr>
                  <tr>
                    <th>Capacidad de plastificación</th>
                    <td>Kg. / Hr.</td>
                    <td>52</td>
                    <td>111.5</td>
                    <td>111.5</td>
                    <td>117</td>
                    <td>117</td>
                  </tr>
                  <tr>
                    <th>Dimensiones de la platinas</th>
                    <td>mm</td>
                    <td>560 X 510</td>
                    <td>440 X 450</td>
                    <td>440 X 450</td>
                    <td>770 X 670</td>
                    <td>800 x 700</td>
                  </tr>
                  <tr>
                    <th>Distancia entre barras</th>
                    <td>mm</td>
                    <td>360 X 310</td>
                    <td>420 X 420</td>
                    <td>420 X 420</td>
                    <td>515 X 415</td>
                    <td>520 x 450</td>
                  </tr>
                  <tr>
                    <th>Espesor mínimos del molde</th>
                    <td>mm</td>
                    <td>202</td>
                    <td>140</td>
                    <td>140</td>
                    <td>210</td>
                    <td>250</td>
                  </tr>
                  <tr>
                    <th>Espesor máximo del molde</th>
                    <td>mm</td>
                    <td>407</td>
                    <td>395</td>
                    <td>395</td>
                    <td>410</td>
                    <td>450</td>
                  </tr>
                  <tr>
                    <th>Anillo centrador</th>
                    <td>mm / Inch.</td>
                    <td>101.52 / 3.997</td>
                    <td>101.52 / 3.997</td>
                    <td>101.52 / 3.997</td>
                    <td>101.52 / 3.997</td>
                    <td>101.52 / 3.997</td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
}
</script>
